/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux"
import { Panel, BackgroundPanel, } from "vr-react-components";
import EnginesSelectionWidget from "../../../widgets/EnginesSelectionWidget/EnginesSelectionWidget";
import BarPanelWidget from "../../../widgets/BarWidget/BarPanelWidget";
import CriticalJobsWidget from "../../../widgets/CriticalJobsWidget/CriticalJobsWidget";
import DisplayingPlansWidget from "../../../widgets/DisplayingPlansWidget";

const RightPanelDesktop = React.memo(({ width, height }) => {
    const currentRoom = useSelector((state) => state.room.history[0].ID);
    const canModify = useSelector((state) => state.private.device.canModify);

    const innerWidth = width * 0.9;
    const innerHeight = height * 0.9;
    const padding = innerWidth / 50;
    const textSize = 45 / innerWidth;

    return (
        <BackgroundPanel backgroundColor="#121212" width={width} height={height}>
            <EnginesSelectionWidget
                backgroundColor="#262626"
                width={innerWidth * 0.4 - padding}
                height={innerHeight * 0.2 - padding}
                position={`${-width / 2 + innerWidth * 0.2 + width * 0.05} ${height / 2 - innerHeight * 0.1 - height * 0.05
                    } 0.001`}
                textSizeDecimal={textSize}
            />
            <DisplayingPlansWidget
                width={innerWidth * 0.4 - padding}
                height={innerHeight * 0.3 - padding}
                position={`${-width / 2 + innerWidth * 0.2 + width * 0.05} ${innerHeight * 0.15
                    } 0.001`}
                backgroundColor={"#262626"}
                textOffset={{
                    x: (innerWidth * 0.4 - padding) / 20,
                    y: (innerHeight * 0.5 - padding) / 20,
                }}
                textSizeDecimal={textSize}
                arrows="bottom"
            />

            <CriticalJobsWidget
                width={innerWidth * 0.6 - padding}
                height={innerHeight / 2 - padding}
                position={`${width / 2 - innerWidth * 0.3 - width * 0.05} ${height / 2 - innerHeight / 4 - height * 0.05
                    } 0.001`}
                textSizeDecimal={textSize}
                isClickable
            />
            <Panel
                position={`0 ${-height / 2 + innerHeight / 4 + height * 0.05} 0.001`}
                panel
                width={innerWidth - padding}
                height={innerHeight / 2 - padding}
                aframeClasses={canModify ? "collidable" : ""}
                backgroundColor="#262626"
                resize
                title="Job Status (grouped data)"
                textSizeDecimal={textSize}
            >
                <BarPanelWidget
                    grouped
                    flat
                    stateName={"dataRightChart"}
                    currentRoom={currentRoom}
                    aspectRatio={1.5}
                />
            </Panel>
        </BackgroundPanel>
    );
});

export default RightPanelDesktop;